import { stringifyStyle } from "@vue/shared";

//根据type保存的回调函数
window._EnumCallbackFunc_ = {
  "*": function () {
    return [];
  },
};

/*
 * 枚举对象使用时须通过引用并进行初始化
 * import enums from './enums'
 * Vue.use(enums);
 */
export function Enum(cache) {
  Enum.prototype.cache = cache;
  Enum.prototype.ENUMKEY = "__ENUM_KEY__";
  Enum.prototype.callbackHanler = function () {};
}

//当参数为function时回调 回调函数须为同步请求
/*
 *Vue.prototype.$enum.callback(function(type){
 *  return = Vue.prototype.$http.xpost("/dds/dictionary/get", { dic_type: "product_status" }, "", true)
 *})
 */
Enum.prototype.callback = function (callback) {
  if (typeof callback != "function") {
    throw new Error("无效参数，类型:function(type){return [];}返回一个数组");
  }
  this.callbackHanler = callback;
};

//==============================保存、更新数据===========================================
//全量添加数据
Enum.prototype.set = function (data) {
  this.checkData(data);
  let rdata = this.groupByType(data);
  this.set2Cache(rdata);
};
Enum.prototype.append = function (data) {
  //分组数据
  let groupData = this.groupByType(data);

  //覆盖已有数据
  let enumLst = this.getFromCache() || {};
  for (let key in groupData) {
    enumLst[key] = groupData[key];
  }

  //保存到缓存
  this.set2Cache(enumLst);
  return;
};

//将数据按分组方式呈现
Enum.prototype.groupByType = function (data) {
  if (!data) {
    return {};
  }
  let groupData = {};
  data.forEach(function (item) {
    var tp = item.type;
    if (!groupData[tp]) {
      groupData[tp] = [];
    }
    if (!item.pid || !Array.isArray(item.pid)) {
      item.pid=!item.pid?[]:item.pid.split(",")
    }
    if (!item.group || !Array.isArray(item.group)) {
      item.group=!item.group?[]:item.group.split(",")
    }
    item.text = item.name || "";
    groupData[tp].push(item);
  });
  return groupData;
};
//============================================================================================

//================================获取枚举数据================================================

//数据获取
Enum.prototype.get = function (type,pids = "",group = "",all = false,url = "") {
  if (!type) return [];
  let pidLst = (pids || "").split(",") || [""];
  let lst = [];
  pidLst = pidLst.length == 0 ? [""] : pidLst;
  pidLst.forEach((pid) => {
    var result = this.getByPidOrGroup(type, pid, group, all); //根据存储查询
    if (result.length == 0) {
      result = this.getByCallback(type, pid, group, all, url); //根据回调获取
    }
    lst = lst.concat(result);
  });
  return lst;
};

Enum.prototype.getByValue = function (type, value = "", def = "-") {
  if (!value) return def;
  var result = [];
  var data = value.split(",");
  var enumMap = this.get(type, null, null, true);
  for (var i = 0; i < data.length; i++) {
    for (var j = 0; j < enumMap.length; j++) {
      if (enumMap[j].value == data[i]) {
        result.push(enumMap[j]);
        break;
      }
    }
  }
  return result;
};

Enum.prototype.getTreeNames = function (type,value = "",sp = "/",level = 99) {
  let lst = [];
  let tps = (value || "").split(",") || [];
  let that = this;
  tps.forEach((tp) => {
    let d = that.getTreeName(type, tp, sp, level);
    if (d) lst.push(d);
  });
  return lst.join(", ");
};

Enum.prototype.getTreeName = function (type, value = "", sp = "/", level = 99) {
  if (level == 0) return "";
  let exp = this.getByValue(type, value);
  if (exp.length == 0) return "";
  let current = exp[0];
  let pids = current.pid || [];
  let labels = [];
  if (pids.length > 0 && pids[0] != "") {
    let lab = this.getTreeName(type, pids[0], sp, level - 1);
    if (lab != "") labels.push(lab);
  } else {
    return current.text;
  }
  labels.push(current.text);
  return labels.join(sp);
};

//数据获取
Enum.prototype.getTree = function (type, pid = "", group = "", deep = 99,url="") {
  let lst = this.get(type, null, group,false,url);
  let vmap = {};
  let enumLst = [];
  let contains = function (lst, m) {
    let c = false;
    lst.forEach((v) => {
      if (v == m) {
        c = true;
      }
    });
    return c;
  };
  lst.forEach((v) => {
    v.id = v.value;
    if (!vmap[v.pid]) {
      vmap[v.pid] = [];
    }
   
    vmap[v.pid].push(v);
    if (!v.pid||v.pid.length==0 ||contains(v.pid, pid)||contains(v.pid, pid||"0")) {
      enumLst.push(v);
    }
  });
  let resetChildren = function (lst, map, deep) {
    lst.forEach((v) => {
      let id = v.value;
      let children = map[id];
      if (deep == 0 || !children) {
        v["children"] = [];
        return;
      }
      v["children"] = children;
      resetChildren(children, map, deep - 1);
    });
  };
  resetChildren(enumLst, vmap, deep - 1);
  return enumLst;
};

//根据value值获取name
Enum.prototype.getName = function (type, value, group, jx = "/") {
  if (!value) {
    return "-";
  }
  var enumMap = this.get(type, null, group, true);
  var data = value.split(",");
  var result = [];
  for (var i = 0; i < data.length; i++) {
    for (var j = 0; j < enumMap.length; j++) {
      if (enumMap[j].value == data[i]) {
        result.push(enumMap[j].name);
        break;
      }
    }
  }
  if (result.length == 0) {
    return value;
  }
  return result.join(jx || "/");
};
//对应type数据刷新
Enum.prototype.clear = function (type) {
  if (!type) {
    this.cache.remove(this.ENUMKEY);
    return;
  }
  let data = this.cache.get(this.ENUMKEY) || {};
  data[type] = null;
  this.cache.set(this.ENUMKEY, data);
};
Enum.prototype.getFromCache = function (tp) {
  let data = this.cache.get(this.ENUMKEY);
  if (tp && data) {
    return data[tp] || [];
  }
  return data;
};
Enum.prototype.set2Cache = function (v) {
  this.cache.set(this.ENUMKEY, v);
};

//数据格式检查
Enum.prototype.checkData = function (data) {
  if (!data || !Array.isArray(data)) {
    throw new Error(
      "数据格式错误，" +
        JSON.stringify(data) +
        "格式:[{type:'zxc',name:'上架',value:'1', pid: 1002},...]其中type与pid参数为非必要参数，name与value为必要参数"
    );
  }
  for (var i = 0; i < data.length; i++) {
    if (
      !Object.prototype.hasOwnProperty.call(data[i], "name") ||
      !Object.prototype.hasOwnProperty.call(data[i], "value")
    ) {
      throw new Error(
        "数据格式错误，" +
          JSON.stringify(data) +
          "格式:[{type:'zxc',name:'上架',value:'1', pid: 1002},...]其中type与pid参数为非必要参数，name与value为必要参数"
      );
    }
  }
  return true;
};
Enum.prototype.has = function (lst, item) {
  let exists = false;
  lst.forEach((v) => {
    if (v.value == item.value) {
      exists = true;
    }
  });
  return exists;
};
//根据回调函数获取数据
Enum.prototype.getByCallback = function (type, pid, group, all, url) {
  var data = this.callbackHanler.apply(this, [type, url]);
  this.append(data);
  return this.getByPidOrGroup(type, pid, group, all) || [];
};

//根据type获取相应的数据
Enum.prototype.getByPidOrGroup = function (type, pid, group, all = false) {
  var enumLst = this.getFromCache() || {};
  var list = enumLst[type] || [];
  var nlist = [];
  list.forEach((item) => {
    let checkGroup=(!group || item.group.length==0||(item.group || []).includes(group))
    let checkPID= (!pid||item.pid.length==0||item.pid.includes(pid)) 
    let checkStatus = all||(item.hasOwnProperty("status") && item.status == "0")||(!item.hasOwnProperty("status") && item.hasOwnProperty("mstatus") && item.mstatus == "1")||!item.hasOwnProperty("status")
    if(checkGroup && checkPID && checkStatus){
      nlist.push(item);
    }
  });
  return nlist;
};
